import { render } from "./LockItInSummary.vue?vue&type=template&id=4035c702&scoped=true"
import script from "./LockItInSummary.vue?vue&type=script&lang=js"
export * from "./LockItInSummary.vue?vue&type=script&lang=js"

import "./LockItInSummary.vue?vue&type=style&index=0&id=4035c702&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4035c702"]])

export default __exports__